export default __webpack_public_path__ + "static/CanadasIndigenousfoodrenaissance-f54eb97af545c642f9df60575c7330dd.jpg";